import { default as _Vue } from 'vue';
import { Store } from 'vuex';
import { AbstractEventEmitterService } from '@/plugins/podolib/lib/AbstractEventService';

// Service options type
export type TOptions = {};

/**
 * @author Damien CORLER <d.corler@zhortech.com>
 * @since 1.0.0
 * @version 1.0.0
 */
export default class BusService extends AbstractEventEmitterService {
  /**
   * @param options
   */
  constructor(options: TOptions) {
    super(options, 'bus');
  }

  /**
   * Initialize plugin
   */
  async init(Vue: typeof _Vue, store: Store<any>) {
    await super.init(Vue, store);
  }
}
